import * as React from 'react';
import {createPortal} from 'react-dom';

/**
 * Holds the DOM node of the top-bar action slot (rendered by MainPane beside
 * the breadcrumb). Null until that slot mounts.
 */
const HeaderActionsContext = React.createContext<HTMLElement | null>(null);

/** MainPane wraps the routed app in this, passing the mounted slot element. */
export const HeaderActionsProvider = HeaderActionsContext.Provider;

/**
 * Portals its children into the shared top bar, on the same row as the page's
 * breadcrumb title, so a page can place its action buttons there instead of
 * spending a second header row on them — space that matters on mobile. Renders
 * nothing until the slot mounts, and unmounting cleanly clears the actions.
 */
export const HeaderActions = ({children}: {children: React.ReactNode}) => {
  const slot = React.useContext(HeaderActionsContext);
  return slot ? createPortal(children, slot) : null;
};
